export const RECOIL_ATOM_KEYS = {
  HOME_WRAP_DISPLAY: "home_wrap_display",
  EASY_SENTENCE: "easy_sentence",
  GAME_STATUS: "gameStatus",
  LOADING: "loading",
  FIELD_DATA: "field_data",
  SELECT_SQUARE: "select_square",
  SELECTED_SQUARES: "selected_squares",
  SELECT_SQUARE_BTN_COLOR: "select_square_btn_color",
  PLAYER1_CURRENT_SQUARE: "player1_current_square",
  PLAYER1_HAS_WORDS: "player1_has_words",
  EASY_PLAYER_HAS_WORDS: "easy_player_has_words",
  BACKPACK_DISPLAY: "backpack_display",
  GAMESTATUS_INFO: "gamestatus_info",
  GAMESTATUS_INFO_DISPLAY: "gamestatus_info_display",
  HONEYCOMB_DISPLAY: "honeycomb_display",
  ISREVERSE: "isReverse",
  WARP_WINDOW_DISPLAY_STATE: "warp_window_display_state",
  HCBSWORD_STATUS: "hcbsword_status",
  HCB_WINDOW_DISPLAY_STATE: "hcb",
  USER_DATA: "user_data",
  USER_DATA_UPDATE_FLAG: "user_data_update_flag",
  CERTIFICATION_WINDOW_DISPLAY: "certification_window_display",
  BRING_ITEM_STATE: "bring_item_state",
  MP_STATE: "mp_state",
  THIS_GAME_POINT_STATE: "this_game_point_state",
  GAMEOVER_DISPLAY: "gameover_display_state",
  TREASURE_CHEST_STATE: "treasure_chest_state",
  TEACHER_ID: "teacher_id",
  LEVEL_STATE: "level_state",
  BOOLDRUGON_EGG_STATE: "bool_drugon_egg_state",
  USE_ITEM_AREA_STATE: "use_item_area_state",
  SENTENCE_RANGE_STATE: "sentence_range_state"

};
export const RECOIL_SELECTOR_KEYS = {

};
